import configureAxios from 'configure/axios';

const axios = configureAxios();

export const findCurrent = (subId) => axios.get(`quick/subscriptions/${subId}/get_usage/`);
